import { createStyles } from '@mui/styles';
import { APTheme } from "../../../../core/TenantProvider/tenants";

const drawerWidth = 260;
export default (theme: APTheme) =>
  createStyles(
    (() => {
      return {
        root: {
          display: "flex",
          width: 360,
        },
        drawer: {
          width: drawerWidth,
          flexShrink: 0,
        },
        drawerOpen: {
          width: drawerWidth,
          transition: theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
          }),
        },
        drawerClose: {
          transition: theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
          }),
          width: theme.spacing(5) + 1,
          [theme.breakpoints.up("xs")]: {
            width: theme.spacing(10) + 1,
          },
        },
        toolbar: {
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          padding: theme.spacing(0, 1),
          // necessary for content to be below app bar
          ...theme.mixins.toolbar,
        },
        content: {
          flexGrow: 1,
          padding: theme.spacing(3),
        },
        label: {
          fontWeight: 400,
          "&:hover, &:active": {
            fontWeight: 700,
          },
        },
      };
    })()
  );
